import { AppBar, Avatar, Box, createStyles, Drawer, LinearProgress, List, ListItem, ListItemText, makeStyles, Menu, MenuItem, Toolbar } from '@material-ui/core';
import LoopFront from 'loop-front';
import { AppState } from 'Models/App/@types';
import { UserState } from 'Models/Users/@types';
import React, { FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, Route, RouteComponentProps, Switch } from 'react-router-dom';
import Definitions from 'screens/Definitions';
import Users from 'screens/Users';
import { ReduxStore } from 'stores';
import { OUser } from '../../Models/Users/Model';
import MuiTheme from '../../MuiTheme';
import { TDispatch } from '../../Resources/GarbageUtils';
import utilities from '../../Resources/Utils';
import Solutions from '../Solutions';
import Tags from '../Tags';
import WeeklyTech from '../WeeklyTech'

const BaseUrl = '/dashboard';

const NAV_LINK_CONFIG = [
    {
        name: 'Solutions',
        url: 'books-solutions/books',
        baseUrl: 'books-solutions',
        component: Solutions
    },
    {
        name: 'Tech Crunch',
        url: 'weekly-tech',
        baseUrl: 'weekly-tech',
        component: WeeklyTech
    },
    {
        name: 'Definitions',
        url: 'definitions',
        baseUrl: 'definitions',
        component: Definitions
    },
    {
        name: 'Tags',
        url: 'tags',
        baseUrl: 'tags',
        component: Tags
    },
    {
        name: 'Users',
        url: 'users',
        baseUrl: 'users',
        component: Users
    }
]

type IStateProps = Pick<UserState, 'appUser'> & Pick<AppState, 'isAppLinearLoaderVisible'>;

const Dashboard: FC<RouteComponentProps> = (props) => {

    const [profileOptions, setProfileOptions] = useState<(EventTarget & HTMLDivElement) | null>(null);
    const { isAppLinearLoaderVisible, appUser } = useSelector<ReduxStore, IStateProps>(({ App: { isAppLinearLoaderVisible }, Users: { appUser } }) => ({ isAppLinearLoaderVisible, appUser }));
    const dispatch = useDispatch<TDispatch>();

    const handleLogout = async () => {
        LoopFront.setAuthHeader();
        utilities.clearCookies();
        dispatch(OUser.postActivity(OUser.Activities.LOGOUT));
        props.history.push('/');
    }

    const classes = useStyles();
    return (
        <div className={classes.root} >
            <Drawer variant='permanent' elevation={3} className={classes.drawer} classes={{ paper: classes.drawerPaper }} >
                <List className={classes.list} disablePadding >
                    {
                        NAV_LINK_CONFIG.map((item, i) => {
                            return (
                                <NavLink
                                    key={i}
                                    to={`${BaseUrl}/${item.url}`}
                                    className={classes.inactiveTab}
                                    activeClassName={'activeTab'}
                                    isActive={(match, location) => location.pathname.split('/')[2] === item.baseUrl}
                                >
                                    <ListItem button >
                                        <ListItemText primaryTypographyProps={{ variant: 'subtitle2', color: 'inherit' }} >{item.name}</ListItemText>
                                    </ListItem>
                                </NavLink>
                            )
                        })
                    }
                </List>
            </Drawer>
            <AppBar position='fixed' className={classes.appBar} >
                <Toolbar className={classes.toolbar} >
                    <div onClick={e => setProfileOptions(e.currentTarget)} >
                        <Avatar src={appUser?._profileImage?.thumbnail} />
                    </div>
                    <Menu open={Boolean(profileOptions)} anchorEl={profileOptions} onClose={e => setProfileOptions(null)} >
                        <MenuItem onClick={handleLogout} >Logout</MenuItem>
                    </Menu>
                </Toolbar>
            </AppBar>

            <div className={classes.container} >
                {isAppLinearLoaderVisible ? <LinearProgress classes={{ root: classes.loaderRoot }} /> : <Box height={7} width={'100%'} />}
                <Switch>
                    {NAV_LINK_CONFIG.map((item, i) => <Route key={i} path={`/dashboard/${item.baseUrl}`} component={item.component} />)}
                </Switch>
            </div>

        </div>
    )

}


const drawerWidth = 150

const useStyles = makeStyles((theme: typeof MuiTheme) => {

    const { palette: { text, secondary } } = theme;

    return (createStyles({
        root: {
            paddingTop: 64, paddingLeft: drawerWidth,
            flex: 1
        },
        drawer: {
            width: drawerWidth,
        },
        drawerPaper: {
            width: drawerWidth,
            paddingTop: 72,
            backgroundColor: text['primary']
        },
        appBar: {
            marginLeft: drawerWidth,
            width: `calc(100% - ${drawerWidth}px)`,
            backgroundColor: 'white'
        },
        toolbar: {
            display: 'flex',
            flexDirection: 'row-reverse',
            '& > div': {
                cursor: 'pointer'
            }
        },
        list: {
            marginTop: 64,
            '& > .activeTab > div': {
                backgroundColor: secondary.main,
                color: '#fff'
            }
        },
        inactiveTab: {
            color: '#fff'
        },
        container: {
            height: 'calc(100vh - 64px)',
        },
        loaderRoot: { width: '100%', height: 7 }
    }))
});

export default Dashboard;